import { n as P } from "./Logger-CmiOOsKC.js";
import { c as ee, l as te, s as se, t as U } from "./tracebehavior-5_qSKjs6.js";
import { a as M, r as w, t as R } from "./TransitionManager-BD_yHXIb.js";
import { Matrix as H, Quaternion as D, Vector3 as b } from "@babylonjs/core/Maths/math.vector.js";
import { Observable as $ } from "@babylonjs/core/Misc/observable.js";
function T(a) {
  return "driver" in a;
}
function x(a) {
  return "duration" in a;
}
function re(a) {
  if (a)
    return a.every((e) => typeof e == "number") ? a : void 0;
}
function z(a) {
  return a ? [
    a.position,
    a.rotation,
    a.scale
  ].some((e) => e && !re(e)) : !1;
}
var ge = 1;
function ie(a) {
  if (Array.isArray(a)) return {
    version: 1,
    declarations: a
  };
  if (!a || typeof a != "object") return null;
  const e = a;
  return e.version !== 1 ? null : {
    version: e.version,
    ...typeof e.label == "string" ? { label: e.label } : {},
    declarations: Array.isArray(e.declarations) ? e.declarations : void 0
  };
}
function oe(a) {
  if (!a || typeof a != "object" || Array.isArray(a)) return !1;
  const e = a.styles;
  return !!e && typeof e == "object";
}
var ne = {
  Meters: 1,
  Feet: 0.3048
}, ae = {
  Meters: "m",
  Feet: "ft"
}, q = /* @__PURE__ */ new Set();
function W(a) {
  if (a === void 0) return 1;
  const e = ne[a];
  return typeof e != "number" ? (q.has(a) || (q.add(a), P.warn(`[Canopy] Unknown units "${a}" — treating the value as canonical metres.`)), 1) : e;
}
function ce(a) {
  if (a)
    return a.type === "number" || a.type === "vec3" ? a.units : void 0;
}
function ye(a) {
  if (a !== void 0)
    return ae[a];
}
function Q(a, e) {
  return typeof a == "number" ? e(a) : Array.isArray(a) && a.length === 3 ? [
    e(a[0]),
    e(a[1]),
    e(a[2])
  ] : a;
}
function he(a, e) {
  const t = W(a);
  return t === 1 ? e : Q(e, (s) => s * t);
}
function le(a, e) {
  const t = W(a);
  return t === 1 ? e : Q(e, (s) => s / t);
}
var L = {
  ":active": 40,
  ":selected": 30,
  ":hover": 20
}, V = 10, I = 0;
function be(a) {
  I++;
  try {
    return a();
  } finally {
    I--;
  }
}
var ue = class g {
  _propertyMap = /* @__PURE__ */ new Map();
  _subscribers = /* @__PURE__ */ new Map();
  _stateStack = [];
  _editorPick = void 0;
  _pickStack = [];
  get _shown() {
    return this._editorPick === void 0 ? this._stateStack : this._pickStack;
  }
  _baseValues = /* @__PURE__ */ new Map();
  _contributions = /* @__PURE__ */ new Map();
  _contributionSeq = 0;
  _eligibleStatesCache = null;
  _runtimeOverrides = /* @__PURE__ */ new Map();
  _transitionValues = /* @__PURE__ */ new Map();
  _activeTransitionKeys = /* @__PURE__ */ new Set();
  _transitionTargets = /* @__PURE__ */ new Map();
  _exitBarriers = [];
  _startedKeyCapture = null;
  _propertyDriverTargets = /* @__PURE__ */ new Map();
  _propertyDriverSources = /* @__PURE__ */ new Map();
  _driverSubscriptions = /* @__PURE__ */ new Map();
  _systemDriverNames = /* @__PURE__ */ new Set();
  _hasActiveTransformOverride = !1;
  _hasActiveEnabledOverride = !1;
  constructor(e, t, s, r) {
    this._nodeAdapter = e, this._transitionHost = t, this._callbacks = s, this._getAuthored = r;
  }
  rebuildPropertyMap(e, t) {
    this._propertyMap.clear();
    for (const s of t) this._propertyMap.has(s.name) || this._propertyMap.set(s.name, s);
    for (const s of e) this._propertyMap.set(s.name, s);
  }
  getPropertyMap() {
    return this._propertyMap;
  }
  getValue(e, t = !1) {
    return he(this._unitsOf(e), this._getDeclaredValue(e, t));
  }
  _unitsOf(e) {
    return ce(this._propertyMap.get(e));
  }
  _getDeclaredValue(e, t = !1) {
    if (!this.hasProperty(e)) return;
    if (I === 0) {
      if (!t) {
        const i = this._transitionValues.get(e);
        if (i !== void 0) return i;
      }
      const r = this._runtimeOverrides.get(e);
      if (r !== void 0) return r;
      if (this._shown.length > 0 || this._contributions.size > 0) {
        const i = this._resolveEligibleStates();
        for (const o of i) if (Object.hasOwn(o.values, e) && o.values[e] !== void 0) return o.values[e];
      }
    }
    const s = this._propertyMap.get(e);
    if (s?.inherits !== !1) {
      const r = this._resolveAncestorValue(e);
      if (r !== void 0) return r;
    }
    return s?.value;
  }
  hasProperty(e) {
    if (this._propertyMap.has(e)) return !0;
    const t = this._getAuthored().states;
    if (t) {
      for (const s of Object.values(t)) if (Object.hasOwn(s.values, e)) return !0;
    }
    for (const s of this._contributions.values()) if (Object.hasOwn(s.def.values, e)) return !0;
    return !1;
  }
  getProperty(e) {
    return this._propertyMap.get(e);
  }
  getPropertyNames() {
    return Array.from(this._propertyMap.keys());
  }
  getProperties() {
    return Array.from(this._propertyMap.values());
  }
  getLabeledProperties() {
    return Array.from(this._propertyMap.values()).filter((e) => e.label !== void 0);
  }
  getCurrentValue(e) {
    const t = this._runtimeOverrides.get(e);
    if (t !== void 0) return t;
    if (this._shown.length > 0 || this._contributions.size > 0) {
      const r = this._resolveEligibleStates();
      for (const i of r) if (Object.hasOwn(i.values, e) && i.values[e] !== void 0) return i.values[e];
    }
    const s = this._propertyMap.get(e);
    if (s?.inherits !== !1) {
      const r = this._resolveAncestorValue(e);
      if (r !== void 0) return r;
    }
    return s?.value;
  }
  _resolveAncestorValue(e) {
    for (const t of this._nodeAdapter.walkAncestorProviders()) if (t.hasProperty(e)) {
      const s = t.getValue(e);
      if (s !== void 0) return le(this._unitsOf(e), s);
    }
  }
  _declTransition(e) {
    return this._propertyMap.get(e)?.transition;
  }
  setValue(e, t, s) {
    let r = s ?? this._declTransition(e);
    this._activeTransitionKeys.has(e) && !this._propertyDriverTargets.has(e) && g._valuesEqual(this._transitionTargets.get(e), t) && (r = void 0);
    const i = this._transitionValues.get(e) ?? this.getCurrentValue(e);
    return this._runtimeOverrides.set(e, t), this._applyValue(e, t, r, i);
  }
  _applyValue(e, t, s, r) {
    if (!this.hasProperty(e)) return !1;
    const i = this._propertyMap.get(e);
    if (i && !g._typeCheck(i.type, t)) return !1;
    const o = r ?? this._transitionValues.get(e) ?? this._baseValues.get(e) ?? i?.value ?? t;
    return s && x(s) && g._timeTransitionApplies(s) ? this._startTransition(e, o, t, s) : (this._activeTransitionKeys.has(e) && (this._transitionHost.cancelTransition(e), this._activeTransitionKeys.delete(e), this._transitionTargets.delete(e), this._drainTransitionKey(e)), this._transitionValues.delete(e), this._notifySubscribers(e), this._cascadePropertyChange(e)), !0;
  }
  clearRuntimeOverrides() {
    if (this._runtimeOverrides.size === 0) return;
    const e = [...this._runtimeOverrides.keys()];
    this._runtimeOverrides.clear();
    for (const t of e)
      this._activeTransitionKeys.has(t) && (this._transitionHost.cancelTransition(t), this._activeTransitionKeys.delete(t), this._transitionTargets.delete(t), this._drainTransitionKey(t)), this._transitionValues.delete(t), this._notifySubscribers(t), this._cascadePropertyChange(t);
  }
  setTransitionValue(e, t) {
    this._transitionValues.set(e, t), this._notifySubscribers(e), this._cascadePropertyChange(e);
  }
  clearTransitionValue(e) {
    this._transitionValues.delete(e), this._notifySubscribers(e), this._cascadePropertyChange(e);
  }
  isTransitioning(e) {
    return this._activeTransitionKeys.has(e);
  }
  _drainTransitionKey(e) {
    if (this._exitBarriers.length === 0) return;
    const t = [];
    this._exitBarriers = this._exitBarriers.filter((s) => (s.keys.delete(e), s.keys.size === 0 ? (t.push(s.resolve), !1) : !0));
    for (const s of t) s();
  }
  get activeTransitionCount() {
    return this._activeTransitionKeys.size;
  }
  _startTransition(e, t, s, r) {
    this._transitionValues.set(e, t), this._activeTransitionKeys.add(e), this._transitionTargets.set(e, s), this._startedKeyCapture?.add(e), this._startTransitionTicks(e, t, s, r), this._notifySubscribers(e), this._cascadePropertyChange(e);
  }
  _startTransitionTicks(e, t, s, r) {
    this._transitionHost.startTransition(e, r, (i) => {
      const o = i === 1 ? s : M(t, s, i);
      g._valuesEqual(this._transitionValues.get(e), o) || (this._transitionValues.set(e, o), this._notifySubscribers(e), this._cascadePropertyChange(e));
    }, () => {
      this._transitionValues.delete(e), this._activeTransitionKeys.delete(e), this._transitionTargets.delete(e), this._drainTransitionKey(e), this._notifySubscribers(e), this._cascadePropertyChange(e);
    });
  }
  stopAllTransitions() {
    if (this.teardownAllPropertyDrivers(), this._activeTransitionKeys.size === 0) return;
    const e = [...this._activeTransitionKeys], t = /* @__PURE__ */ new Set([...this._transitionValues.keys(), ...e]);
    for (const s of this._activeTransitionKeys) this._transitionHost.cancelTransition(s);
    this._transitionValues.clear(), this._activeTransitionKeys.clear(), this._transitionTargets.clear();
    for (const s of e) this._drainTransitionKey(s);
    for (const s of t)
      this._notifySubscribers(s), this._cascadePropertyChange(s);
  }
  getActiveState() {
    return this._shown.length > 0 ? this._shown[0].name : void 0;
  }
  getActiveStates() {
    return this._shown.map((e) => e.name);
  }
  getRuntimeState() {
    return this._stateStack.length > 0 ? this._stateStack[0].name : void 0;
  }
  getEditorState() {
    return this._editorPick;
  }
  setEditorState(e, t = !1) {
    let s = e ? this._pickEntries(e) : [];
    const r = e === "" || !s ? void 0 : e;
    if (r === this._editorPick) return;
    s ??= [];
    const i = this.getActiveState(), o = this._shown.find((c) => !c.name.startsWith(":"))?.name, n = this._captureDisplayValues();
    this._editorPick = r, this._pickStack = s, this._invalidateEligibleStatesCache();
    const h = s.length > 0 ? s[s.length - 1].name : o;
    this._recomputeFromStack(t, i, n, void 0, h);
  }
  _pickEntries(e) {
    const t = e.indexOf(":"), s = t < 0 ? e : e.substring(0, t), r = t < 0 ? void 0 : e.substring(t);
    if (s && !this.hasState(s) || r && !this._hasPseudoReference(r)) return null;
    const i = [];
    return r && i.push({
      name: r,
      priority: L[r] ?? V
    }), s && i.push({
      name: s,
      priority: V
    }), i;
  }
  hasState(e) {
    return !!this._getAuthored().states?.[e];
  }
  getStateTransition(e) {
    return this._getAuthored().states?.[e]?.transition;
  }
  getStateNames() {
    const e = this._getAuthored();
    return e.states ? Object.keys(e.states) : [];
  }
  hasPseudoStates() {
    return this.getStateNames().some((e) => e.includes(":"));
  }
  setState(e, t = !1, s) {
    if (e !== void 0 && !this.hasState(e)) return;
    const r = this._stateStack.findIndex((h) => !h.name.startsWith(":")), i = r < 0 ? void 0 : this._stateStack[r].name;
    if (e === i) return;
    if (r < 0) {
      this._pushToStack(e, V, t, s);
      return;
    }
    const o = this.getActiveState(), n = this._captureDisplayValues();
    this._stateStack.splice(r, 1), this._invalidateEligibleStatesCache(), e !== void 0 && this._insertStackEntry(e, V), this._recomputeFromStack(t, o, n, s, e ?? i);
  }
  setStateAwaited(e, t = !1, s) {
    const r = /* @__PURE__ */ new Set(), i = this._startedKeyCapture;
    this._startedKeyCapture = r;
    try {
      this.setState(e, t, s);
    } finally {
      this._startedKeyCapture = i;
    }
    for (const o of [...r]) this._activeTransitionKeys.has(o) || r.delete(o);
    return r.size === 0 ? Promise.resolve() : new Promise((o) => {
      this._exitBarriers.push({
        keys: r,
        resolve: o
      });
    });
  }
  resetStates() {
    if (this._stateStack.length === 0 && this._editorPick === void 0) return;
    const e = this.getActiveState();
    this._stateStack.length = 0, this._editorPick = void 0, this._pickStack = [], this._invalidateEligibleStatesCache(), this._recomputeFromStack(!0, e);
  }
  setPseudoState(e, t, s = !1) {
    if (t) {
      if (!this._hasPseudoReference(e) || this._stateStack.some((i) => i.name === e)) return;
      const r = L[e] ?? V;
      this._pushToStack(e, r, s);
    } else this._removeFromStack(e, s);
  }
  hasPseudoReference(e) {
    return this._hasPseudoReference(e);
  }
  _hasPseudoReference(e) {
    const t = this._getAuthored().states;
    if (!t) return !1;
    for (const s of Object.keys(t)) {
      if (s === e) return !0;
      const r = s.indexOf(":");
      if (r > 0 && s.substring(r) === e) return !0;
    }
    return !1;
  }
  pushContribution(e, t, s, r = !1, i) {
    const o = `${e}:${t}`, n = this.getActiveState(), h = this._captureDisplayValues();
    this._contributions.set(o, {
      contributorId: e,
      name: t,
      def: s,
      seq: ++this._contributionSeq
    }), this._invalidateEligibleStatesCache(), this._recomputeFromStack(r, n, h, i, t);
  }
  clearContribution(e, t, s = !1, r) {
    const i = `${e}:${t}`;
    if (!this._contributions.has(i)) return;
    const o = this.getActiveState(), n = this._captureDisplayValues();
    this._contributions.delete(i), this._invalidateEligibleStatesCache(), this._recomputeFromStack(s, o, n, r, t);
  }
  replaceContribution(e, t, s, r, i = !1, o) {
    const n = `${e}:${t}`, h = `${e}:${s}`, c = this.getActiveState(), u = this._captureDisplayValues();
    n !== h && this._contributions.delete(n), this._contributions.set(h, {
      contributorId: e,
      name: s,
      def: r,
      seq: ++this._contributionSeq
    }), this._invalidateEligibleStatesCache(), this._recomputeFromStack(i, c, u, o, s);
  }
  clearAllContributions(e, t = !1, s) {
    let r = !1;
    const i = this.getActiveState(), o = this._captureDisplayValues();
    for (const [n, h] of this._contributions) h.contributorId === e && (this._contributions.delete(n), r = !0);
    r && (this._invalidateEligibleStatesCache(), this._recomputeFromStack(t, i, o, s));
  }
  applyInitialState() {
    const e = this._getAuthored().initialState;
    if (e && this.hasState(e)) {
      const t = this._getAuthored().states?.[e]?.transition, s = !t || !T(t);
      this.setState(e, s);
    }
  }
  _pushToStack(e, t, s = !1, r) {
    const i = this.getActiveState(), o = this._captureDisplayValues();
    this._insertStackEntry(e, t), this._recomputeFromStack(s, i, o, r, e);
  }
  _insertStackEntry(e, t) {
    const s = {
      name: e,
      priority: t
    };
    let r = !1;
    for (let i = 0; i < this._stateStack.length; i++) if (t > this._stateStack[i].priority) {
      this._stateStack.splice(i, 0, s), r = !0;
      break;
    }
    r || this._stateStack.push(s), this._invalidateEligibleStatesCache();
  }
  _removeFromStack(e, t = !1) {
    const s = this._stateStack.findIndex((o) => o.name === e);
    if (s < 0) return;
    const r = this.getActiveState(), i = this._captureDisplayValues();
    this._stateStack.splice(s, 1), this._invalidateEligibleStatesCache(), this._recomputeFromStack(t, r, i, void 0, e);
  }
  _resolveEligibleStates() {
    if (this._eligibleStatesCache) return this._eligibleStatesCache;
    const e = this._getAuthored(), t = this._shown.find((c) => !c.name.startsWith(":"))?.name, s = new Set(this._shown.filter((c) => c.name.startsWith(":")).map((c) => c.name)), r = [], i = [], o = [];
    if (e.states) for (const [c, u] of Object.entries(e.states)) {
      if (c === "default") continue;
      const d = c.indexOf(":");
      if (d > 0) {
        const v = c.substring(0, d), y = c.substring(d);
        v === t && s.has(y) && r.push(u);
      } else if (d === 0) {
        if (s.has(c)) {
          const v = this._shown.find((y) => y.name === c);
          i.push({
            priority: v?.priority ?? 0,
            def: u
          });
        }
      } else c === t && o.push(u);
    }
    const n = [];
    if (this._contributions.size > 0) {
      const c = Array.from(this._contributions.values()).sort((u, d) => d.seq - u.seq);
      for (const u of c) n.push(u.def);
    }
    i.sort((c, u) => u.priority - c.priority);
    const h = [
      ...r,
      ...i.map((c) => c.def),
      ...o,
      ...n
    ];
    return this._eligibleStatesCache = h, h;
  }
  _resolveInitiatingTransition(e) {
    const t = this._getAuthored().states;
    if (!t) return;
    const s = this._shown.find((o) => !o.name.startsWith(":"))?.name, r = this._shown.filter((o) => o.name.startsWith(":")).map((o) => o.name), i = [];
    if (e.startsWith(":"))
      s && i.push(`${s}${e}`), i.push(e), s && i.push(s);
    else {
      for (const o of r) i.push(`${e}${o}`);
      i.push(e);
    }
    for (const o of i) {
      const n = t[o]?.transition;
      if (n) return n;
    }
  }
  _invalidateEligibleStatesCache() {
    this._eligibleStatesCache = null;
  }
  _captureDisplayValues() {
    const e = /* @__PURE__ */ new Map();
    for (const [s] of this._propertyMap) {
      const r = this._transitionValues.get(s) ?? this.getCurrentValue(s);
      r !== void 0 && e.set(s, r);
    }
    const t = this._getAuthored();
    if (t.states) {
      for (const s of Object.values(t.states)) for (const r of Object.keys(s.values)) if (!e.has(r)) {
        const i = this._transitionValues.get(r) ?? this.getCurrentValue(r);
        i !== void 0 && e.set(r, i);
      }
    }
    return e;
  }
  _recomputeFromStack(e, t, s, r, i) {
    const o = this._getAuthored(), n = { duration: 0 }, h = this.getActiveState();
    h !== t && this._callbacks.onStateChanged(t, h);
    const c = this._resolveEligibleStates(), u = t ? o.states?.[t] : void 0, d = i ? this._resolveInitiatingTransition(i) : void 0, v = e ? n : d ?? u?.transition ?? r, y = /* @__PURE__ */ new Map();
    for (const l of c) for (const [f, _] of Object.entries(l.values)) y.has(f) || y.set(f, {
      value: _,
      transition: l.transition
    });
    for (const [l] of y) if (!this._baseValues.has(l)) {
      const f = this._propertyMap.get(l), _ = (f?.inherits !== !1 ? this._resolveAncestorValue(l) : void 0) ?? f?.value;
      _ !== void 0 && this._baseValues.set(l, _);
    }
    for (const [l, f] of this._propertyDriverTargets) {
      const _ = y.get(l);
      _ ? _.transition !== void 0 && T(_.transition) && _.transition.driver === f.config.driver || (!_.transition || !T(_.transition)) && (c.some((m) => m.transition && T(m.transition) && m.transition.driver === f.config.driver && Object.hasOwn(m.values, l) && m.values[l] !== void 0) || this._teardownPropertyDriver(l)) : this._teardownPropertyDriver(l);
    }
    const F = [];
    for (const [l, { value: f, transition: _ }] of y) {
      this._runtimeOverrides.delete(l);
      const m = this._propertyDriverTargets.has(l) && _ && T(_) ? _ : v ?? this._declTransition(l);
      this._applyValueSilent(l, f, m, s?.get(l)), F.push(l);
    }
    const G = v && x(v) ? v : void 0, J = e ? n : r ?? G;
    for (const [l, f] of this._baseValues)
      y.has(l) || (this._applyValueSilent(l, f, J ?? this._declTransition(l), s?.get(l)), F.push(l), this._baseValues.delete(l));
    for (const l of F)
      this._notifySubscribers(l), this._cascadePropertyChange(l);
    let E, k, S, A, O, C;
    for (const l of c) {
      const f = l.transform;
      if (f && (S || (S = l), !A && f.position && (A = f.position), !O && f.rotation && (O = f.rotation), !C && f.scale && (C = f.scale)), !E && l.active !== void 0 && (E = l), !k && l.enterFrom && (k = l), A && O && C && E && k) break;
    }
    const K = A || O || C ? {
      ...A ? { position: A } : {},
      ...O ? { rotation: O } : {},
      ...C ? { scale: C } : {}
    } : void 0, X = this._hasActiveEnabledOverride, j = E?.active, Z = !this._callbacks.getHostActive() && j === !0 && k ? k.enterFrom : void 0;
    if (j !== void 0 ? this._callbacks.applyStateActive(j, v) : X && this._callbacks.applyStateActive(void 0, v), this._hasActiveEnabledOverride = j !== void 0, S?.transition && T(S.transition) && S) {
      const l = S.transition;
      this._callbacks.setupTransformDriver(S, l);
      const f = l.driver;
      this._driverSubscriptions.has(f) || this._subscribeToDriver(f);
      let _ = this._propertyDriverSources.get(f);
      _ || (_ = /* @__PURE__ */ new Set(), this._propertyDriverSources.set(f, _)), _.add("__transform__");
    } else {
      this._callbacks.teardownTransformDriver();
      const l = v, f = K !== void 0 ? {
        values: {},
        transform: K
      } : void 0;
      this._callbacks.applyStateTransform(f, this._hasActiveTransformOverride, l, Z);
    }
    this._hasActiveTransformOverride = S !== void 0;
  }
  _applyValueSilent(e, t, s, r) {
    if (!this.hasProperty(e)) return;
    const i = this._propertyMap.get(e);
    if (i && !g._typeCheck(i.type, t)) return;
    const o = i?.type ?? g._inferType(t);
    if (s && T(s) && g._isInterpolable(o)) {
      const n = this._baseValues.get(e) ?? i?.value ?? t;
      this._setupPropertyDriver(e, n, t, s);
    } else if (s && x(s) && g._timeTransitionApplies(s)) {
      const n = this._transitionValues.get(e) ?? r ?? this._baseValues.get(e) ?? i?.value ?? t;
      this._transitionValues.set(e, n), this._activeTransitionKeys.add(e), this._transitionTargets.set(e, t), this._startedKeyCapture?.add(e), this._startTransitionTicks(e, n, t, s);
    } else
      this._activeTransitionKeys.has(e) && !this._propertyDriverTargets.has(e) && (this._transitionHost.cancelTransition(e), this._activeTransitionKeys.delete(e), this._transitionTargets.delete(e), this._drainTransitionKey(e)), this._transitionValues.delete(e);
  }
  _setupPropertyDriver(e, t, s, r) {
    const i = r.driver;
    if (this._transitionTargets.delete(e), i === e || this._propertyDriverTargets.has(i)) {
      this._transitionValues.set(e, s);
      return;
    }
    const o = this._propertyDriverTargets.get(e);
    if (o && o.config.driver === i && o.config.range?.[0] === r.range?.[0] && o.config.range?.[1] === r.range?.[1] && o.config.easing === r.easing) {
      const u = w(this._resolveDriverValue(i), r.range, r.easing), d = u === 1 ? o.toValue : u === 0 ? o.fromValue : M(o.fromValue, o.toValue, u);
      this._transitionValues.set(e, d);
      return;
    }
    this._teardownPropertyDriver(e), this._propertyDriverTargets.set(e, {
      config: r,
      fromValue: t,
      toValue: s
    });
    let n = this._propertyDriverSources.get(i);
    n || (n = /* @__PURE__ */ new Set(), this._propertyDriverSources.set(i, n)), n.add(e), this._driverSubscriptions.has(i) || this._subscribeToDriver(i);
    const h = w(this._resolveDriverValue(i), r.range, r.easing), c = h === 1 ? s : h === 0 ? t : M(t, s, h);
    this._transitionValues.set(e, c), this._activeTransitionKeys.add(e);
  }
  _teardownPropertyDriver(e) {
    const t = this._propertyDriverTargets.get(e);
    if (!t) return;
    const s = t.config.driver;
    this._propertyDriverTargets.delete(e);
    const r = this._propertyDriverSources.get(s);
    r && (r.delete(e), r.size === 0 && (this._propertyDriverSources.delete(s), this._unsubscribeFromDriver(s)));
  }
  teardownAllPropertyDrivers() {
    for (const e of [...this._driverSubscriptions.keys()]) this._unsubscribeFromDriver(e);
    this._systemDriverNames.clear(), this._propertyDriverTargets.clear(), this._propertyDriverSources.clear(), this._callbacks.teardownTransformDriver();
  }
  onDriverValueChanged(e) {
    const t = this._propertyDriverSources.get(e);
    if (!t || t.size === 0) return;
    const s = this._resolveDriverValue(e), r = [];
    for (const i of t) {
      if (i === "__transform__") {
        this._callbacks.onTransformDriverValueChanged(e, s);
        continue;
      }
      const o = this._propertyDriverTargets.get(i);
      if (!o) continue;
      const n = w(s, o.config.range, o.config.easing), h = n === 1 ? o.toValue : n === 0 ? o.fromValue : M(o.fromValue, o.toValue, n);
      this._transitionValues.set(i, h), r.push(i);
    }
    for (const i of r)
      this._notifySubscribers(i), this._cascadePropertyChange(i);
  }
  resolveDriverValue(e) {
    return this._resolveDriverValue(e);
  }
  _resolveDriverValue(e) {
    const t = this.getCurrentValue(e);
    if (typeof t == "number") return t;
    const s = this._resolveAncestorValue(e);
    if (typeof s == "number") return s;
    const r = this._callbacks.resolveDriverExpression(e);
    return typeof r == "number" ? r : NaN;
  }
  getSystemDriverNames() {
    return this._systemDriverNames;
  }
  getPropertyDriverSources() {
    return this._propertyDriverSources;
  }
  _subscribeToDriver(e) {
    const t = this._findDriverProvider(e);
    if (!t) {
      this._systemDriverNames.add(e);
      return;
    }
    const s = {
      _onPropertyChanged: (r) => {
        r === e && this.onDriverValueChanged(e);
      },
      _resubscribeAndResolve: () => {
        this._unsubscribeFromDriver(e), this._propertyDriverSources.has(e) && (this._subscribeToDriver(e), this.onDriverValueChanged(e));
      }
    };
    t.subscribe(e, s), this._driverSubscriptions.set(e, {
      provider: t,
      subscriber: s
    });
  }
  _unsubscribeFromDriver(e) {
    const t = this._driverSubscriptions.get(e);
    t && (t.provider.unsubscribe(e, t.subscriber), this._driverSubscriptions.delete(e)), this._systemDriverNames.delete(e);
  }
  _findDriverProvider(e) {
    if (this.hasProperty(e)) return this;
    for (const t of this._nodeAdapter.walkAncestorProviders()) if (t.hasProperty(e)) return t;
    return null;
  }
  handleCommit(e, t) {
    const s = new Map(this._propertyMap), r = new Set(this._propertyMap.keys());
    this.rebuildPropertyMap(e, t);
    for (const [n] of this._runtimeOverrides) {
      const h = s.get(n), c = this._propertyMap.get(n);
      if (!g._valuesEqual(h?.value, c?.value)) {
        this._runtimeOverrides.delete(n);
        continue;
      }
      h?.inherits !== c?.inherits && this._runtimeOverrides.delete(n);
    }
    const i = this.getActiveState();
    if (this._stateStack = this._stateStack.filter((n) => n.name.startsWith(":") ? this._hasPseudoReference(n.name) : this.hasState(n.name)), this._editorPick && !this._pickEntries(this._editorPick)) {
      const n = this._editorPick.split(":")[0], h = n && this.hasState(n) ? n : void 0;
      this._editorPick = h, this._pickStack = h ? [{
        name: h,
        priority: V
      }] : [];
    }
    this._invalidateEligibleStatesCache(), this._baseValues.clear(), this.stopAllTransitions(), this._shown.length > 0 ? this._recomputeFromStack(!0, i) : (this._hasActiveTransformOverride = !1, this._hasActiveEnabledOverride = !1, i !== void 0 && this._callbacks.onStateChanged(i, void 0));
    let o = r.size !== this._propertyMap.size;
    if (!o) {
      for (const n of this._propertyMap.keys()) if (!r.has(n)) {
        o = !0;
        break;
      }
    }
    this._notifyAllSubscribers();
    for (const n of this._propertyMap.keys()) this._cascadePropertyChange(n);
    return { namesChanged: o };
  }
  _cascadePropertyChange(e) {
    for (const t of this._nodeAdapter.getChildren()) this._cascadeToChild(t, e);
  }
  _cascadeToChild(e, t) {
    const s = e.getProvider();
    if (s && s.hasProperty(t)) {
      if (s._propertyMap?.get(t)?.inherits === !1) return;
      s instanceof g && (s._notifySubscribers(t), s._cascadePropertyChange(t));
      return;
    }
    for (const r of e.getChildren()) this._cascadeToChild(r, t);
  }
  subscribe(e, t) {
    let s = this._subscribers.get(e);
    s || (s = /* @__PURE__ */ new Set(), this._subscribers.set(e, s)), s.add(t);
  }
  unsubscribe(e, t) {
    const s = this._subscribers.get(e);
    s && (s.delete(t), s.size === 0 && this._subscribers.delete(e));
  }
  unsubscribeAll(e) {
    for (const [, t] of this._subscribers) t.delete(e);
  }
  _notifySubscribers(e) {
    const t = this._subscribers.get(e);
    if (t)
      for (const s of t) s._onPropertyChanged(e);
  }
  _notifyAllSubscribers() {
    for (const [e, t] of this._subscribers) for (const s of t) s._onPropertyChanged(e);
  }
  dispose() {
    this.stopAllTransitions();
    const e = this._exitBarriers;
    this._exitBarriers = [];
    for (const t of e) t.resolve();
    this._propertyMap.clear(), this._subscribers.clear(), this._stateStack.length = 0, this._editorPick = void 0, this._pickStack = [], this._invalidateEligibleStatesCache(), this._baseValues.clear(), this._runtimeOverrides.clear(), this._contributions.clear(), this._hasActiveTransformOverride = !1, this._hasActiveEnabledOverride = !1;
  }
  get hasActiveTransformOverride() {
    return this._hasActiveTransformOverride;
  }
  getBaseValues() {
    return this._baseValues;
  }
  getStateStack() {
    return this._shown;
  }
  static _isInterpolable(e) {
    return e === "number" || e === "color" || e === "vec3" || e === "vec4" || e === "Vector3";
  }
  static _timeTransitionApplies(e) {
    return e.duration > 0 || (e.delay ?? 0) > 0;
  }
  static valuesEqual(e, t) {
    return g._valuesEqual(e, t);
  }
  static _valuesEqual(e, t) {
    if (e === t) return !0;
    if (e == null || t == null) return !1;
    if (Array.isArray(e) && Array.isArray(t)) {
      if (e.length !== t.length) return !1;
      for (let s = 0; s < e.length; s++) if (e[s] !== t[s]) return !1;
      return !0;
    }
    return e === t;
  }
  static _inferType(e) {
    return typeof e == "number" ? "number" : typeof e == "boolean" ? "boolean" : Array.isArray(e) && e.length === 4 ? "vec4" : Array.isArray(e) && e.length === 3 ? "vec3" : typeof e == "string" && e.startsWith("#") ? "color" : "string";
  }
  static typeCheck(e, t) {
    return g._typeCheck(e, t);
  }
  static _typeCheck(e, t) {
    switch (e) {
      case "string":
        return typeof t == "string";
      case "number":
        return typeof t == "number";
      case "boolean":
        return typeof t == "boolean";
      case "color":
        return typeof t == "string";
      case "vec3":
        return Array.isArray(t) && t.length === 3;
      case "vec4":
        return Array.isArray(t) && t.length === 4;
      case "Vector3":
        return Array.isArray(t) && t.length === 3;
      default:
        return !1;
    }
  }
}, Y = !1;
function Se(a) {
  Y = a;
}
var B = 1e-6;
function N({ pos: a, rot: e, scl: t }, s) {
  const r = {
    pos: new b(),
    rot: new D(),
    scl: new b()
  };
  return H.Compose(t, e, a).multiply(s).decompose(r.scl, r.rot, r.pos), r;
}
var me = class p extends U {
  static behaviorType = "Properties";
  _resolverInstance;
  get _resolver() {
    return this._resolverInstance || (this._resolverInstance = this._createResolver()), this._resolverInstance;
  }
  _loadedSheets = /* @__PURE__ */ new Map();
  onValueChanged = null;
  onValueChangedObservable = new $();
  onStateChangedObservable = new $();
  _savedTransform;
  _savedTransformUnauthored;
  _baselineStale = !1;
  _deactivationTimer = null;
  _removeSelectionRegistration = null;
  _systemDriverObserver = null;
  _transformDriver = null;
  _createResolver() {
    return new ue(this._createNodeAdapter(), this._createTransitionHost(), this._createCallbacks(), () => this.getAuthored());
  }
  _createNodeAdapter() {
    return {
      getParentProvider: () => this.sceneObject.getParent()?.getBehavior(p)?._resolver ?? null,
      walkAncestorProviders: () => {
        const e = [];
        let t = this.sceneObject.getParent();
        for (; t; ) {
          const s = t.getBehavior(p);
          s && e.push(s._resolver), t = t.getParent();
        }
        return e;
      },
      getChildren: () => this.sceneObject.getChildren().map((e) => this._wrapChild(e)),
      notifyDependentBehaviors: () => {
        this._notifyDependentBehaviors();
      }
    };
  }
  _wrapChild(e) {
    return {
      getProvider: () => e.getBehavior(p)?._resolver ?? null,
      getChildren: () => e.getChildren().map((t) => this._wrapChild(t))
    };
  }
  _createTransitionHost() {
    return {
      startTransition: (e, t, s, r) => {
        const i = `${this._transitionPrefix}${e}`;
        R(this.scene).start(i, t, s, r);
      },
      cancelTransition: (e) => {
        R(this.scene).cancel(`${this._transitionPrefix}${e}`);
      },
      hasTransition: (e) => R(this.scene).has(`${this._transitionPrefix}${e}`)
    };
  }
  _createCallbacks() {
    return {
      resolveDriverExpression: (e) => this._resolveDriverExpression(e),
      onStateChanged: (e, t) => {
        this.onStateChangedObservable.notifyObservers({
          prev: e,
          next: t
        });
      },
      applyStateTransform: (e, t, s, r) => {
        this._applyStateTransform(e, t, s, r);
      },
      applyStateActive: (e, t) => {
        this._applyStateActive(e, t);
      },
      setupTransformDriver: (e, t) => {
        this._setupTransformDriver(e, t);
      },
      teardownTransformDriver: () => {
        this._transformDriver = null;
      },
      onTransformDriverValueChanged: (e, t) => {
        this._updateTransformFromDriver();
      },
      getHostActive: () => this.sceneObject.active
    };
  }
  get _transitionPrefix() {
    return `props:${this.sceneObject.transform.uniqueId}:`;
  }
  init() {
    this._resolver.rebuildPropertyMap(this.getAuthored().properties ?? [], this._getSheetDeclarations());
  }
  async load() {
    await this._loadExternalSheets(), this._resolver.rebuildPropertyMap(this.getAuthored().properties ?? [], this._getSheetDeclarations());
  }
  onAttach() {
    this._resolver.rebuildPropertyMap(this.getAuthored().properties ?? [], this._getSheetDeclarations()), this._installSystemDriverObserver(), this._updateSelectionRegistration(), this._applyBaseTransform(), this._notifyDependentBehaviors();
  }
  onDetach() {
    this._resolver.stopAllTransitions(), this._uninstallSystemDriverObserver(), this._removeSelectionRegistration && (this._removeSelectionRegistration(), this._removeSelectionRegistration = null), this._cancelDeactivation(), this.sceneObject.setActiveOverride(void 0), this._resolver.dispose(), this._loadedSheets.clear(), this.onValueChanged = null, this.onValueChangedObservable.clear(), this.onStateChangedObservable.clear(), this._savedTransform = void 0, this._savedTransformUnauthored = void 0, this._notifyDependentBehaviors();
  }
  async applyCommit(e) {
    await this._loadExternalSheets(), this._baselineStale = !0, this._cancelDeactivation();
    const { namesChanged: t } = this._resolver.handleCommit(this.getAuthored().properties ?? [], this._getSheetDeclarations());
    if (this._refreshStaleBaseline(), this._resolver.getStateStack().length === 0) {
      if (this._savedTransform) {
        const { pos: s, rot: r, scl: i } = this._savedTransform;
        this.sceneObject.setTransform({
          position: s,
          rotation: r,
          scale: i
        }, null);
      }
      this.sceneObject.setActiveOverride(void 0), this._savedTransform = void 0, this._savedTransformUnauthored = void 0;
    }
    if (t && this._notifyDependentBehaviors(), this._updateSelectionRegistration(), this._applyBaseTransform(), this.onValueChanged && e.properties) for (const s of e.properties) this.onValueChanged(s.name, s.value);
  }
  _onPropertyChanged(e) {
    const { patch: t, hasChanges: s } = this._reresolve(), r = Object.keys(t);
    if (r.length === 1 && r[0] === "transform") {
      this._applyBaseTransform();
      return;
    }
    s && this._applyResolvedPatch(t), this._applyBaseTransform();
  }
  onPlayModeChanged(e) {
    e ? (this._adoptLiveRestPoseForUnauthoredFields(), this._resolver.applyInitialState()) : this._resolver.clearRuntimeOverrides();
  }
  getValue(e, t = !1) {
    return this._resolver.getValue(e, t);
  }
  hasProperty(e) {
    return this._resolver.hasProperty(e);
  }
  subscribe(e, t) {
    this._resolver.subscribe(e, t);
  }
  unsubscribe(e, t) {
    this._resolver.unsubscribe(e, t);
  }
  unsubscribeAll(e) {
    this._resolver.unsubscribeAll(e);
  }
  getProperty(e) {
    return this._resolver.getProperty(e);
  }
  getPropertyNames() {
    return this._resolver.getPropertyNames();
  }
  getDeclaredValues(e) {
    const t = [], s = /* @__PURE__ */ new Set(), r = (n) => {
      const h = typeof n == "object" ? JSON.stringify(n) : `${typeof n}:${String(n)}`;
      s.has(h) || (s.add(h), t.push(n));
    }, i = this._resolver.getProperty(e);
    i && r(i.value);
    const o = this.getAuthored().states;
    if (o)
      for (const n of Object.values(o)) n.values && Object.hasOwn(n.values, e) && r(n.values[e]);
    return t;
  }
  getProperties() {
    return this._resolver.getProperties();
  }
  getLabeledProperties() {
    return this._resolver.getLabeledProperties();
  }
  getSheetDeclarations() {
    return this._getSheetDeclarations();
  }
  setValue(e, t, s) {
    return this._resolver.setValue(e, t, s) ? (this.onValueChanged?.(e, t), this.onValueChangedObservable.notifyObservers({
      name: e,
      value: t
    }), !0) : !1;
  }
  clearRuntimeOverrides() {
    this._resolver.clearRuntimeOverrides();
  }
  stopAllTransitions() {
    this._resolver.stopAllTransitions();
  }
  isTransitioning(e) {
    return this._resolver.isTransitioning(e);
  }
  get activeTransitionCount() {
    return this._resolver.activeTransitionCount;
  }
  _setTransitionValue(e, t) {
    this._resolver.setTransitionValue(e, t);
  }
  _clearTransitionValue(e) {
    this._resolver.clearTransitionValue(e);
  }
  getActiveState() {
    return this._resolver.getActiveState();
  }
  getRuntimeState() {
    return this._resolver.getRuntimeState();
  }
  getEditorState() {
    return this._resolver.getEditorState();
  }
  setEditorState(e, t = !1) {
    this._resolver.setEditorState(e, t);
  }
  getActiveStates() {
    return this._resolver.getActiveStates();
  }
  hasState(e) {
    return this._resolver.hasState(e);
  }
  getStateTransition(e) {
    return this._resolver.getStateTransition(e);
  }
  getStateNames() {
    return this._resolver.getStateNames();
  }
  isStateGroupOwner() {
    return this.getAuthored().stateGroup === !0;
  }
  hasPseudoStates() {
    return this._resolver.hasPseudoStates();
  }
  async setStateAwaited(e, t = !1, s) {
    const r = this._resolver.setStateAwaited(e, t, s), i = t ? void 0 : this._playExitClipIfDeactivating(e);
    i ? await Promise.all([r, i]) : await r;
  }
  _playExitClipIfDeactivating(e) {
    const t = this.getAuthored().states;
    if ((e !== void 0 ? t?.[e]?.active : void 0) !== !1) return;
    const s = this.sceneObject.getBehavior("AnimationSequence")?.getExit?.();
    if (!(!s || s.isEmpty))
      return s.play();
  }
  setState(e, t = !1, s) {
    Y && e !== void 0 && !this.hasState(e) && P.warn(`[Properties] setState("${e}") ignored on ${this.sceneObject.getPath()} — state not declared (dangling reference?)`), this._resolver.setState(e, t, s);
  }
  resetStates() {
    this._resolver.resetStates();
  }
  setPseudoState(e, t, s = !1) {
    this._resolver.setPseudoState(e, t, s);
  }
  pushContribution(e, t, s, r = !1, i) {
    this._resolver.pushContribution(e, t, s, r, i);
  }
  clearContribution(e, t, s = !1, r) {
    this._resolver.clearContribution(e, t, s, r);
  }
  clearAllContributions(e, t = !1, s) {
    this._resolver.clearAllContributions(e, t, s);
  }
  replaceContribution(e, t, s, r, i = !1, o) {
    this._resolver.replaceContribution(e, t, s, r, i, o);
  }
  resetSavedTransform() {
    this._savedTransform = void 0, this._savedTransformUnauthored = void 0;
  }
  primeSavedTransform() {
    this._ensureSavedTransform();
  }
  setRestPose(e) {
    this._savedTransform && (e.position && (this._savedTransform.pos = e.position.clone(), this._savedTransformUnauthored && (this._savedTransformUnauthored.pos = !1)), e.scale && (this._savedTransform.scl = e.scale.clone(), this._savedTransformUnauthored && (this._savedTransformUnauthored.scl = !1)));
  }
  onParentFrameChanged(e, t) {
    const s = e.multiply(H.Invert(t)), r = this.getAuthored(), i = !this.playMode && (!!r.transform || Object.values(r.states ?? {}).some((c) => c.transform || c.enterFrom));
    if (i && this._ensureSavedTransform(), !this._savedTransform) return;
    const o = this._savedTransform, n = N(o, s);
    if (this._savedTransform = n, !i) return;
    const h = {};
    for (const [c, u] of Object.entries(r.states ?? {})) {
      const d = p._reframeOverride(u.transform, o, n, s), v = u.transform && z(u.transform) ? u.enterFrom : p._reframeOverride(u.enterFrom, p._overridePose(o, u.transform), p._overridePose(n, d), s);
      h[c] = {
        ...u,
        ...d && { transform: d },
        ...v && { enterFrom: v }
      };
    }
    this._replaceAuthored({
      ...r,
      ...r.states && { states: h },
      ...r.transform && { transform: p._reframeOverride(r.transform, o, n, s) }
    });
  }
  getAuthoredTransform() {
    if (this._savedTransform)
      return {
        position: this._savedTransform.pos.clone(),
        rotation: this._savedTransform.rot.clone(),
        scale: this._savedTransform.scl.clone()
      };
  }
  getAuthoredActive() {
    return this.sceneObject.authoredActive;
  }
  onPointerEvent(e, t) {
    e === "hover" ? this.setPseudoState(":hover", t) : e === "active" && this.setPseudoState(":active", t);
  }
  get propertyMap() {
    return this._resolver.getPropertyMap();
  }
  _getSheetDeclarations() {
    const e = [];
    for (const t of this.getAuthored().sheets ?? []) {
      const s = this._loadedSheets.get(t);
      s?.declarations && e.push(...s.declarations);
    }
    return e;
  }
  getSheetUrls() {
    return this.getAuthored().sheets ?? [];
  }
  getLoadedSheet(e) {
    return this._loadedSheets.get(e) ?? null;
  }
  async _loadExternalSheets() {
    const e = this.getAuthored().sheets ?? [], t = new Set(e);
    for (const s of this._loadedSheets.keys()) t.has(s) || this._loadedSheets.delete(s);
    for (const s of e)
      if (!this._loadedSheets.has(s))
        try {
          const r = await this._fetchSheet(s);
          r ? this._loadedSheets.set(s, r) : P.warn(`[Properties] Failed to parse sheet: ${s}`);
        } catch (r) {
          P.warn(`[Properties] Failed to load sheet: ${s}`, r);
        }
  }
  async _fetchSheet(e) {
    const t = this.sceneObject.resources.getAsset(e);
    if (t) {
      const i = await t.text();
      return p._parseSheet(i);
    }
    const s = await fetch(this.sceneObject.resources.resolveAssetUrl(e) ?? e);
    if (!s.ok) return null;
    const r = await s.text();
    return p._parseSheet(r);
  }
  static _parseSheet(e) {
    try {
      const t = JSON.parse(e), s = ie(t);
      if (!s) {
        const i = t?.version;
        return typeof i == "number" && i !== 1 && P.warn(`[Properties] Sheet version ${i} is not supported (this build reads 1) — sheet ignored`), null;
      }
      const r = s.declarations ?? [];
      for (const i of r)
        if (typeof i != "object" || i === null || typeof i.name != "string" || typeof i.type != "string") return null;
      return r.length === 0 && oe(t) && P.warn("[Properties] Sheet carries a `styles` bundle and no declarations — that shape is no longer read. A style is a sheet: convert each style to a sheet whose `declarations` hold its values."), s;
    } catch {
      return null;
    }
  }
  _updateSelectionRegistration() {
    const e = this._resolver.hasPseudoReference(":selected");
    if (e && !this._removeSelectionRegistration) {
      let t;
      try {
        t = this.sceneObject.traceScene.getRuntimeSelectionManager();
      } catch {
        return;
      }
      this._removeSelectionRegistration = t.register(this.sceneObject, {
        onSelected: () => {
          this.sceneObject.traceScene.isPlayMode() && this.setPseudoState(":selected", !0);
        },
        onDeselected: () => {
          this.sceneObject.traceScene.isPlayMode() && this.setPseudoState(":selected", !1);
        }
      });
    } else !e && this._removeSelectionRegistration && (this._removeSelectionRegistration(), this._removeSelectionRegistration = null);
  }
  _installSystemDriverObserver() {
    this._systemDriverObserver || (this._systemDriverObserver = this.scene.onBeforeRenderObservable.add(() => {
      if (this.sceneObject.traceScene.isPlayMode()) {
        for (const e of this._resolver.getSystemDriverNames()) this._resolver.onDriverValueChanged(e);
        this._transformDriver && this._updateTransformFromDriver();
      }
    }));
  }
  _uninstallSystemDriverObserver() {
    this._systemDriverObserver && (this.scene.onBeforeRenderObservable.remove(this._systemDriverObserver), this._systemDriverObserver = null);
  }
  _resolveDriverExpression(e) {
    if (!this.sceneObject.traceScene.isPlayMode()) return;
    const t = ee(e);
    if (!t) return;
    const s = this.sceneObject.traceScene?.getSystemValues();
    if (!s) return;
    const r = te(t, {
      ...s.buildScope(this.sceneObject.transform),
      ...se
    });
    return typeof r == "number" ? r : void 0;
  }
  _ensureSavedTransform() {
    if (this._refreshStaleBaseline(), this._savedTransform) return;
    const { pose: e, unauthored: t } = this._restPoseFromData();
    this._savedTransform = e, this._savedTransformUnauthored = t, this.playMode && this._adoptLiveRestPoseForUnauthoredFields();
  }
  _restPoseFromData() {
    const e = this.sceneObject.getSceneObjectData().transform, t = e?.translation, s = e?.rotation, r = e?.scale, i = {
      pos: t ? new b(t[0], t[1], t[2]) : b.Zero(),
      rot: s ? new D(s[0], s[1], s[2], s[3]) : D.Identity(),
      scl: r ? new b(r[0], r[1], r[2]) : new b(1, 1, 1)
    }, o = this._resolvedBaseTransform(), n = o ? p._computeTransformTargets(i, o) : void 0;
    return {
      pose: n ? {
        pos: n.toPos,
        rot: n.toRot,
        scl: n.toScl
      } : i,
      unauthored: {
        pos: !t && !o?.position,
        rot: !s && !o?.rotation,
        scl: !r && !o?.scale
      }
    };
  }
  _refreshStaleBaseline() {
    this._baselineStale && (this._baselineStale = !1, this._refreshSavedTransform());
  }
  _refreshSavedTransform() {
    const e = this._savedTransform;
    if (!e) return;
    const { pose: t, unauthored: s } = this._restPoseFromData(), r = this._savedTransformUnauthored === void 0;
    this._savedTransform = {
      pos: r && s.pos ? e.pos : t.pos,
      rot: r && s.rot ? e.rot : t.rot,
      scl: r && s.scl ? e.scl : t.scl
    }, r || (this._savedTransformUnauthored = s);
  }
  _adoptLiveRestPoseForUnauthoredFields() {
    if (!this._savedTransform || !this._savedTransformUnauthored) return;
    const e = this._savedTransformUnauthored;
    if (!e.pos && !e.rot && !e.scl) return;
    const t = this.sceneObject.transform;
    e.pos && (this._savedTransform.pos = t.position.clone()), e.rot && (this._savedTransform.rot = t.rotationQuaternion?.clone() ?? D.FromEulerAngles(t.rotation.x, t.rotation.y, t.rotation.z)), e.scl && (this._savedTransform.scl = t.scaling.clone()), this._savedTransformUnauthored = void 0;
  }
  _resolvedBaseTransform() {
    const e = this.getAuthored().transform;
    if (e)
      return U._resolveValue(e, this.sceneObject);
  }
  _applyBaseTransform() {
    if (!this.getAuthored().transform || (this._refreshSavedTransform(), this._ensureSavedTransform(), this._resolver.hasActiveTransformOverride)) return;
    const { pos: e, rot: t, scl: s } = this._savedTransform;
    this.sceneObject.setTransform({
      position: e,
      rotation: t,
      scale: s
    }, null);
  }
  _applyStateTransform(e, t, s, r) {
    const i = e?.transform;
    if (this._ensureSavedTransform(), !i && !r && !t) return;
    const { pos: o, rot: n, scl: h } = p._overridePose(this._savedTransform, i);
    if (r) {
      const c = p._computeTransformTargets({
        pos: o,
        rot: n,
        scl: h
      }, r);
      this.sceneObject.transform.position.copyFrom(c.toPos), this.sceneObject.transform.rotationQuaternion ? this.sceneObject.transform.rotationQuaternion.copyFrom(c.toRot) : this.sceneObject.transform.rotationQuaternion = c.toRot.clone(), this.sceneObject.transform.scaling.copyFrom(c.toScl);
    }
    this.sceneObject.setTransform({
      position: o,
      rotation: n,
      scale: h
    }, s ?? null);
  }
  _applyStateActive(e, t) {
    if (this._cancelDeactivation(), e === void 0) {
      this.sceneObject.setActiveOverride(void 0);
      return;
    }
    if (e) {
      this.sceneObject.setActiveOverride(!0);
      return;
    }
    const s = t && x(t) ? (t.duration + (t.delay ?? 0)) * 1e3 : 0;
    if (s <= 0) {
      this.sceneObject.setActiveOverride(!1);
      return;
    }
    this._deactivationTimer = R(this.scene).after(s, () => {
      this._deactivationTimer = null, this.sceneObject.setActiveOverride(!1);
    });
  }
  _cancelDeactivation() {
    this._deactivationTimer?.(), this._deactivationTimer = null;
  }
  _setupTransformDriver(e, t) {
    this._ensureSavedTransform();
    const s = this._savedTransform, r = e.transform;
    if (!r) return;
    const { toPos: i, toRot: o, toScl: n } = p._computeTransformTargets(s, r);
    this._transformDriver = {
      config: t,
      fromPos: s.pos.clone(),
      fromRot: s.rot.clone(),
      fromScl: s.scl.clone(),
      toPos: i,
      toRot: o,
      toScl: n
    };
    const h = w(this._resolver.resolveDriverValue(t.driver), t.range, t.easing);
    this._applyInterpolatedTransform(h);
  }
  _updateTransformFromDriver() {
    if (!this._transformDriver) return;
    const e = w(this._resolver.resolveDriverValue(this._transformDriver.config.driver), this._transformDriver.config.range, this._transformDriver.config.easing);
    this._applyInterpolatedTransform(e);
  }
  _applyInterpolatedTransform(e) {
    if (!this._transformDriver) return;
    const { fromPos: t, fromRot: s, fromScl: r, toPos: i, toRot: o, toScl: n } = this._transformDriver;
    if (e === 1) this.sceneObject.setTransform({
      position: i,
      rotation: o,
      scale: n
    }, null);
    else if (e === 0) this.sceneObject.setTransform({
      position: t,
      rotation: s,
      scale: r
    }, null);
    else {
      const h = b.Lerp(t, i, e), c = D.Slerp(s, o, e), u = b.Lerp(r, n, e);
      this.sceneObject.setTransform({
        position: h,
        rotation: c,
        scale: u
      }, null);
    }
  }
  static _overridePose(e, t) {
    if (!t) return e;
    const { toPos: s, toRot: r, toScl: i } = p._computeTransformTargets(e, t);
    return {
      pos: s,
      rot: r,
      scl: i
    };
  }
  static _reframeOverride(e, t, s, r) {
    if (!e || z(e)) return e;
    const i = N(p._overridePose(t, e), r), o = { ...e };
    return (e.position || !i.pos.equalsWithEpsilon(s.pos, B)) && (o.position = [
      i.pos.x,
      i.pos.y,
      i.pos.z
    ]), (e.rotation || Math.abs(D.Dot(i.rot, s.rot)) < 1 - B) && (o.rotation = [
      i.rot.x,
      i.rot.y,
      i.rot.z,
      i.rot.w
    ]), (e.scale || !i.scl.equalsWithEpsilon(s.scl, B)) && (o.scale = [
      i.scl.x,
      i.scl.y,
      i.scl.z
    ]), o;
  }
  static _computeTransformTargets(e, t) {
    const s = (r, i) => p._transformComponent(r, i);
    return {
      toPos: t.position ? new b(s(t.position[0], e.pos.x), s(t.position[1], e.pos.y), s(t.position[2], e.pos.z)) : e.pos.clone(),
      toRot: t.rotation ? new D(s(t.rotation[0], e.rot.x), s(t.rotation[1], e.rot.y), s(t.rotation[2], e.rot.z), s(t.rotation[3], e.rot.w)) : e.rot.clone(),
      toScl: t.scale ? new b(s(t.scale[0], e.scl.x), s(t.scale[1], e.scl.y), s(t.scale[2], e.scl.z)) : e.scl.clone()
    };
  }
  static _transformComponent(e, t) {
    if (typeof e == "number") return Number.isFinite(e) ? e : t;
    const s = Number(e);
    return Number.isFinite(s) ? s : (P.warn(`[Properties] transform component "${e}" does not resolve to a number — keeping the authored value`), t);
  }
  _notifyDependentBehaviors() {
    this.sceneObject._resubscribeAndResolve();
    for (const t of this.sceneObject.getBehaviors()) t !== this && t._resubscribeAndResolve();
    const e = this.sceneObject.getDescendants();
    for (const t of e) {
      t._resubscribeAndResolve();
      for (const s of t.getBehaviors()) s._resubscribeAndResolve();
    }
  }
};
export {
  le as a,
  z as c,
  re as d,
  ie as f,
  ce as i,
  T as l,
  Se as n,
  ye as o,
  be as r,
  ge as s,
  me as t,
  x as u
};

//# sourceMappingURL=properties-C_pgb9zu.js.map